import React from 'react';
import PropTypes from 'prop-types';

import {Box, Stack, TextField, Typography} from 'views/components';
import {Translate, translate} from 'views/module';

const PlaybooksNewName = (props) => {
  const {playbookTitle, setPlaybookTitle} = props;

  return (
    <>
      <Stack sx={{gap: '8px'}}>
        <Typography
          sx={{
            fontSize: '11px',
            fontWeight: 600,
            color: '#A8A49E',
            lineHeight: '100%',
            textTransform: 'uppercase',
          }}
        >
          <Translate expression='playbooks.New.TitleLabel' />
        </Typography>
        <Box
          sx={{
            'borderRadius': '8px',
            'border': '1px solid #E8E4DE',
            'backgroundColor': '#FFFFFF',
            'display': 'flex',
            'alignItems': 'center',
            'overflow': 'hidden',
            '&:focus-within': {
              borderColor: '#DA7955',
            },
          }}
        >
          <Typography
            component='span'
            sx={{
              pl: '12px',
              pr: '4px',
              fontSize: '14px',
              fontWeight: 400,
              color: '#6B6760',
            }}
          >
            /
          </Typography>
          <TextField
            value={playbookTitle}
            onChange={setPlaybookTitle}
            variant='standard'
            placeholder={translate('playbooks.New.TitlePlaceholder')}
            fullWidth
            sx={{
              '& .MuiInputBase-root': {
                backgroundColor: 'transparent',
              },
              '& .MuiInputBase-input': {
                py: '24px',
                pr: '16px',
                fontSize: '14px',
                fontWeight: 400,
                lineHeight: '150%',
                color: '#1A1916',
                boxSizing: 'border-box',
              },
              '& .MuiInputBase-input::placeholder': {
                color: '#A8A49E',
                opacity: 1,
              },
              '& .MuiInput-underline:before': {
                borderBottom: '0',
              },
              '& .MuiInput-underline:after': {
                borderBottom: '0',
              },
              '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
                borderBottom: '0',
              },
            }}
          />
        </Box>
      </Stack>
    </>
  );
};

PlaybooksNewName.propTypes = {
  playbookTitle: PropTypes.string.isRequired,
  setPlaybookTitle: PropTypes.func.isRequired,
};

export default React.memo(PlaybooksNewName);
